@for (user of users; track userTrackBy($index, user)) {
  <div
    id="card-container"
    [class.celo-hoverable]="!hoverDisabled"
    [attr.role]="multiple ? 'checkbox' : 'button'"
    [attr.aria-label]="user.name"
    [attr.aria-checked]="multiple ? user.isSelected : null"
    [attr.aria-disabled]="user.isDisabled"
    [attr.tabindex]="user.isDisabled ? -1 : 0"
    matRipple
    [matRippleDisabled]="rippleDisabled"
    (click)="handleUserClick(user)"
    (keydown.enter)="handleUserClick(user)"
    (keydown.space)="handleUserClick(user); $event.preventDefault()"
  >
    <app-basic-user-avatar-card
      [name]="user.name"
      [suffix]="user.suffix ? user.suffix : null"
      [description]="showDescription ? user.description : null"
      [userId]="user.id"
      [isIdentityVerified]="user.isIdentityVerified"
      [isWorkspaceVerified]="user.isWorkspaceVerified"
      [isProfessionVerified]="user.isProfessionVerified"
      [fetchImage]="user.fetchImage || user.fetchImage === undefined"
      [isTeam]="user.isTeam"
      [leftContentMargin]="leftContentMargin"
    >
      @if (multiple || radio) {
        <ng-container start>
          <app-basic-celo-checkbox
            [checked]="user.isSelected"
            [disabled]="user.isDisabled"
            [radio]="radio"
          ></app-basic-celo-checkbox>
        </ng-container>
      }
      @if (
        selectedContent &&
        (alwaysShowSelectedContent || user.isSelected) &&
        !user.isDisabled
      ) {
        <ng-container
          end
          [ngTemplateOutlet]="selectedContent.templateRef"
        ></ng-container>
      }
    </app-basic-user-avatar-card>
  </div>
}
